import React from 'react';
import {Card, Container} from "react-bootstrap";

const Contact = () => {
    return (
        <Container>
            <h2 className="pt-4 title">CONTACT</h2>
{/*<p className="d-flex justify-content-center align-items-center text-success fw-bold" >To Be Announced (TBA)</p>*/}
            <div className="row">
                <div className="col-md-6">

                    <Card>
                        <Card.Body data-aos="fade-up">
                            <Card.Title>Rafiqul Islam</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'>General Chair, NCIM 2025</span> <br/>
                                 Head, Department of Computer Science and Engineering
                              <br/>
                                Dhaka University of Engineering & Technology (DUET), Gazipur
                            </Card.Text>
                            <Card.Text>
                                 Address: <br/>
                                Office of Head, 2nd Floor, <br/>
                                Old Academic Building <br/>
                                Department of Computer Science and Engineering, <br/> Dhaka University of Engineering
                                & Technology (DUET), Gazipur, Bangladesh.

                                <br/>
                               <b>Email: </b> rafiqul.islam@duet.ac.bd <br/>
                               <b>Mobile: </b> +880xxxxxxxxxxx
                                <br/>
                                <b> Website:</b> <a href="https://profile.duet.ac.bd/u/rafiqul.islam" target="_blank"
                                                    rel="noopener noreferrer">https://profile.duet.ac.bd/u/rafiqul.islam</a>
                            </Card.Text>

                        </Card.Body>
                    </Card>

                </div>
                <div className="col-md-6">
                    <Card >

                        <Card.Body data-aos="fade-down">
                            <Card.Title>Momotaz Begum</Card.Title>

                            <Card.Text >
                                <span className='fw-bold'>Organizing Secretary, NCIM 2025</span> <br/>
                                 Professor, Department of Computer Science and Engineering  <br/>
                                Dhaka University of Engineering & Technology (DUET), Gazipur
                            </Card.Text>
                            <Card.Text>
                                Address: <br/>
                                Room No.: 7021, 6th Floor<br/>
                                New Academic Building <br/>
                                Department of Computer Science and Engineering, <br/> Dhaka University of Engineering
                                & Technology (DUET), Gazipur, Bangladesh.
                                <br/>
                               <b>Email: </b> drmomotaz@duet.ac.bd <br/>
                               <b>Mobile: </b> +88 01907621451
                                <br/>
                                <b>Website:</b> <a href="https://profile.duet.ac.bd/u/drmomotaz" target="_blank"
                                                   rel="noopener noreferrer">https://profile.duet.ac.bd/u/drmomotaz</a>

                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </Container>
    )
}

export default Contact;